import React from 'react';
import { Box } from '@chakra-ui/react';
import './RightAngleIcon.scss';

const RightAngleIcon = props => <Box id="right-angle__icon" {...props} />;

export default RightAngleIcon;
